
var axios = require('axios');
export const OPENSEA_API_OFFSET = 50;

export const resolveEnsDomain = async (
  ensDomainName
) => {
  const query = `
  query lookup($name: String!) {
    domains(where: { name: $name }) {
      resolvedAddress {
        id
      }
    }
  }
  `;
  const variables = { name: ensDomainName };
  try {
    const result = await fetch(
      'https://api.thegraph.com/subgraphs/name/ensdomains/ens',
      { method: 'POST', body: JSON.stringify({ query, variables }) }
    );
    const { data } = await result.json();
    if (!data.domains.length) {
      throw new Error(`Could not resolve ${ensDomainName} via ENS.`);
    }
    const address = data.domains[0].resolvedAddress.id;
    return address;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchOpenseaAssets = async ({
  owner,
  offset,
  apiKey,
})=> {
  try {
    
    // const result = await fetch(
    //   apiUrl,
    //   apiKey ? { headers: { 'X-API-KEY': apiKey } } : {}
    // );
    
    var config = {
      method: 'get',
      url: '/.netlify/functions/indexDB',
      // headers: { 
      //   'api-key': 'SoM6LJ0roSPehSRcm6LxerHBVqjLYmK8HCTHt2i8cDqHBFkC14DrCwHq0WxjGlHJ', 
      //   'Content-Type': 'application/json',
      //   'crossorigin':'true'
      // },
      // data : data
    };

    const result = await axios(config)
    console.log(result)
    if (result.status !== 200) {
      const error = await result.text();
      throw new Error(error);
    }
    const assets = await result.data.filter(item =>!item.error && item.image_url.length>0)
    console.log(assets)
    return assets;
  } catch (error) {
    console.error('fetchAssets failed:', error);
    return [];
  }
  // return[
  //   {id:"22313", name: "nftname1", pfp:"https://www.clipartmax.com/png/small/202-2020897_upenn-women-rugby-university-of-pennsylvania-logo-png.png",
  //   collection:{name:"Student1"},
  //   image_preview_url: "https://lh3.googleusercontent.com/z2SuM5ZlxJNWEUV5LKYNBO2wF3zqQICAj9QhipYG4xb7FHE2Fy5NrTTsLYgsg-4YbUbwRz7-u3HNz0d2i6MNzBecXhBl8KGQ4XFm",
  //   image_url:"https://lh3.googleusercontent.com/z2SuM5ZlxJNWEUV5LKYNBO2wF3zqQICAj9QhipYG4xb7FHE2Fy5NrTTsLYgsg-4YbUbwRz7-u3HNz0d2i6MNzBecXhBl8KGQ4XFm"},
  //   {id:"22314", name: "nftname2", pfp:"https://lh3.googleusercontent.com/u4Y5_zwrf_6OaE2E378Rv1NUhBJwqHQEp3nF2O_R2hHuvE1x9FQfdv2bUzoywukYshQKp4MJXzsDAjPdlKG_nfHaZrimpqyYUKUmzZU=s120",
  //   collection:{name:"Student2"},
  //   image_preview_url: "https://lh3.googleusercontent.com/rboQWOJlmkM4TjKB4kQJb-6r9NPLkA87ySDwq9XX9txVd0ru4mh6RP_r-Ubrv9iTwSHA8hnRNqyDTdzZhF4hL0QUFaZy9bDWI-UA-Q",
  //   image_url:"https://lh3.googleusercontent.com/rboQWOJlmkM4TjKB4kQJb-6r9NPLkA87ySDwq9XX9txVd0ru4mh6RP_r-Ubrv9iTwSHA8hnRNqyDTdzZhF4hL0QUFaZy9bDWI-UA-Q"},

  // ]
};
